import styled from 'styled-components';

export const ControlsSC = styled.div`
  width: 380px;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50px;
  padding-right: 15px;
  padding-left: 15px;
  z-index: 99998;

  left: 0;
  right: 0;

  margin-left: auto;
  margin-right: auto;

  svg {
    width: 50px;
    height: 50px;
    cursor: pointer;
  }

  @media only screen and (max-width: 1366px) {
    width: 280px;
    height: 60px;
    bottom: 10px;
    svg {
      width: 40px;
      height: 40px;
      cursor: pointer;
    }
  }

  &.draggable {
    width: 190px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 10px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 50px;
    padding-right: 10px;
    padding-left: 10px;
    z-index: 99998;
    svg {
      width: 30px;
      height: 30px;
      cursor: pointer;
    }
  }
`;
